import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import OurPeople from "./components/OurPeople";
import Contact from "./components/Contact";
import Testimonials from './components/Testimonials';
// import Awards from './components/Awards';
// import Quote from "./components/Quote";
import Offices from "./components/Offices";
import Footer from "./components/Footer";
import ImmigrationLaw from "./components/ImmigrationLaw";
import FamilyLaw from "./components/FamilyLaw";
import ServiceRoutePage from "./components/ServiceRoutePage";
import ServicePage from "./components/ServicePage";
import PartnerFamilyVisa from "./components/PartnerFamilyVisa";
import VisaRoutePage from "./components/VisaRoutePage";

const Home = () => (
  <div className="relative">
    {/* Floating Lady Justice (desktop only, fixed right, non-scrolling, transparent, left-70% showing, below navbar) */}
    <div
      className="pointer-events-none fixed right-0 top-28 xl:top-32 z-10 hidden lg:block select-none"
      aria-hidden="true"
    >
      <img
        src="/lady-justice.png"
        alt=""
        className="h-[580px] xl:h-[680px] 2xl:h-[760px] w-auto max-w-none object-contain opacity-20 translate-x-[30%]"
      />
    </div>

    <Hero />
    <Services />
    <Testimonials />
    {/* <Awards /> */}
    {/* <Quote /> */}
    <Offices />
  </div>
);

const ScrollToHash = () => {
  const { hash, pathname } = useLocation();

  React.useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const target = document.querySelector(hash);

    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [hash, pathname]);

  return null;
};

function App() {
  return (
    <div className="min-h-screen bg-white">
      <ScrollToHash />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/our-people" element={<OurPeople />} />
          <Route path="/contact" element={<Contact />} />
          <Route
            path="/services/immigration-law"
            element={<ImmigrationLaw />}
          />
          <Route path="/services/family-law" element={<FamilyLaw />} />
          <Route
            path="/services/:categorySlug/:serviceSlug/:subCategorySlug/:routeSlug"
            element={<ServiceRoutePage />}
          />
          <Route
            path="/services/:categorySlug/:serviceSlug/:subCategorySlug"
            element={<ServicePage />}
          />
          <Route
            path="/services/:categorySlug/:serviceSlug/:routeSlug"
            element={<ServiceRoutePage />}
          />
          <Route
            path="/services/:categorySlug/:serviceSlug"
            element={<ServicePage />}
          />
          <Route
            path="/services/partner-and-family-visa"
            element={<PartnerFamilyVisa />}
          />
          <Route
            path="/services/partner-and-family-visa/:slug"
            element={<VisaRoutePage />}
          />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
